import { render } from "./fields_datagrid.vue?vue&type=template&id=5c055ffa"
import script from "./fields_datagrid.vue?vue&type=script&lang=js"
export * from "./fields_datagrid.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__